import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import { CullingComponent } from '../components/CullingComponent';
import { Game } from '../Game';
import { ChunkSpriteData } from '../systems/ChunkSystem';
import { BaseEntity } from './BaseEntity';

export interface FlagStartEntityParams
{
    type: string,
    x: number,
    y: number,
    w: number,
    h: number,
    sx: number,
    sy: number,
    r: number,
    img: string,
}

export class FlagStartEntityBack extends BaseEntity
{
    public sprite!: Sprite;
    public params!: FlagStartEntityParams;
    public culling: CullingComponent;

    constructor()
    {
        super();
        this.culling = this.addComponent(CullingComponent);
    }

    public build(params: FlagStartEntityParams): void
    {
        this.params = params;
        this.sprite = Sprite.from(Shared.assets.getTexture('start-back'));
        this.view.addChild(this.sprite);
        this.sprite.anchor.set(0.5);
        this.sprite.scale.x = this.params.sx;
        this.sprite.scale.y = this.params.sy;
        this.sprite.width = this.params.w;
        this.sprite.height = this.params.h;
        this.z = -0.5;
        this.rotation = this.params.r;
        this.x = this.params.x;
        this.y = this.params.y;
        this.culling.updateBounds();
    }
}

export class FlagStartEntityFront extends BaseEntity
{
    public sprite!: Sprite;
    public params!: FlagStartEntityParams;
    public culling: CullingComponent;

    constructor()
    {
        super();
        this.culling = this.addComponent(CullingComponent);
    }

    public build(params: FlagStartEntityParams): void
    {
        this.params = params;
        this.sprite = Sprite.from(Shared.assets.getTexture('start-front'));
        this.view.addChild(this.sprite);
        this.sprite.anchor.set(0.5);
        this.sprite.scale.x = this.params.sx;
        this.sprite.scale.y = this.params.sy;
        this.sprite.width = this.params.w;
        this.sprite.height = this.params.h;
        this.z = 0.1;
        this.rotation = this.params.r;
        this.x = this.params.x + 130;
        this.y = this.params.y + 10;
        this.culling.updateBounds();
    }
}

export class FlagStartFactory
{
    public static match(data: ChunkSpriteData): boolean
    {
        return data.img !== undefined && data.img.endsWith('start-flag');
    }

    public static create(game: Game, params: FlagStartEntityParams): void
    {
        const back = game.pool.get(FlagStartEntityBack) as any;

        back.build(params);

        game.level.addEntity(back);

        const front = game.pool.get(FlagStartEntityFront) as any;

        front.build(params);

        game.level.addEntity(front);

        game.level.courseStartX = params.x;
        game.level.courseStartY = params.y;
    }
}
